import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PMPhase from '../../components/projectmanager/new/Phase/PMPhase';
import { makeRandomString } from '../../utilities/Utility';
import moment from 'moment-timezone';

class PMPhaseContainer extends Component {

	state = {
		currentItem: null,
		saved: true,
		newCommentLine: {
			uniqueID: '',
			author: '',
			createdBy: '',
			date: '',
			time: '',
			comment: ''
		},
	}

	componentWillMount() {
		this.retrieveAndFilter();
		this.retrieveComments();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;

		let cur = p.reduxData.storedPhases[p.reduxData.currentPhase];
		let filt = p.reduxData.storedTaskGroups.filter(pj => pj.parentID === cur.uniqueID);

		let assignedUsers = p.reduxData.storedUsers.filter(isAssigned);
		let assignedContacts = p.reduxData.storedContacts.filter(isContact);

		this.setState({
			currentItem: cur,
			filteredTGs: filt,
			assignedUsers: assignedUsers,
			assignedContacts: assignedContacts
		})

		function isAssigned(usr) {
			let result = false;
			if (cur.assigned.includes(usr.uniqueID)) {
				result = true;
			}
			return result;
		}

		function isContact(cntc) {
			let result = false;
			if (cur.contacts.includes(cntc.uniqueID.toString())) {
				result = true;
			}
			return result;
		}
	}

	retrieveComments = () => {
		const p = this.props;
		let cur = p.reduxData.storedPhases[p.reduxData.currentPhase];
		p.getComments(cur.uniqueID);
	}

	
	componentFunctions = () => {
		var funcs = [];
		let obj = this;

		Object.getOwnPropertyNames(obj).forEach(function (property) {
			if (typeof obj[property] === 'function') {
				funcs[property] = obj[property];
			}
		});

		return funcs;
	}

	render() {
		const p = this.props;
		return (
			<PMPhase
				{...this.props}
				state={this.state}
				{...this.componentFunctions()}
				BPuniqueID={p.reduxData.currentBP.uniqueID}
			/>
		);
	}

	goBack = () => {
		const { setRoute, changeMode } = this.props;
		changeMode("project", null);
		//setRoute('/projectmanager/');
	}

	toggleSaved = () => {
		this.props.updatePhase(this.state.currentItem);
		this.setState({
			saved: true
		})
	}

	onChange = (value, attr) => {
		let newPhase = Object.assign({}, this.state.currentItem);
		newPhase[attr] = value;
		this.setState({
			currentItem: newPhase,
			saved: false
		})
	}

	addTaskGroup = () => {
		let newTG = {
			uniqueID: makeRandomString(24),
			parentID: this.state.currentItem.uniqueID,
			display: " ... ",
			description: ' ... ',
			phase: this.state.currentItem.display,
			dueDate: '',
			bp: this.state.currentItem.bp,
			tasks: [],
			status: 'planned',
			assigned: []
		}

		this.props.setAttributeByObj({
			overlayEditType: 'taskgroup',
			temp: newTG
		});

		this.props.openOverlay('pmEdit');
	}

	addAssigned = (e) => {
		let newPH = Object.assign({}, this.state.currentItem);
		newPH.assigned = [...newPH.assigned, e.uniqueID];
		this.props.updatePhase(newPH);
	}

	removeAssigned = (user) => {
		let newPH = Object.assign({}, this.state.currentItem);
		newPH.assigned = newPH.assigned.filter(usr => usr !== user.uniqueID);
		this.props.updatePhase(newPH);
	}

	addAssignedContact = (e) => {
		let newPH = Object.assign({}, this.state.currentItem);
		if (!newPH.contacts.includes(e.uniqueID.toString())) {
			newPH.contacts =[...newPH.contacts, e.uniqueID];
			this.props.updatePhase(newPH);
		}
	}

	removeAssignedContact = (user) => {
		let newPH = Object.assign({}, this.state.currentItem);
		newPH.contacts = newPH.contacts.filter(usr => usr !== user.uniqueID);
		this.props.updatePhase(newPH);
	}

	addAdditionalDetail = () => {
		const p = this.props;
		const { currentUser } = p.reduxData;

		let temp = Object.assign({}, this.state.newCommentLine);
		temp.parentID = this.state.currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		//temp.author = getUserName(currentUser);
		temp.date = moment(new Date()).format('MM/DD/YYYY');
		temp.time = new moment().format("HH:mm A");

		p.saveComment(temp);

		this.setState({
			newCommentLine: {
				uniqueID: '',
				author: '',
				createdBy: '',
				date: '',
				time: '',
				comment: ''
			}
		})
	}

	onChangeAdditionalDetail = (value, returnObj) => {
		let newComment = Object.assign({}, this.state.newCommentLine);
		newComment[returnObj.attr] = value;
		this.setState({
			newCommentLine: newComment,
		})
	}

}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		updatePhase: (obj) => {
			dispatch(actions.pm.updatePhase(obj))
		},
		addTaskGroup: (obj) => {
			dispatch(actions.pm.addTaskGroup(obj))
		},
		getComments: (obj) => {
			dispatch(actions.pm.getComments(obj))
		},
		saveComment: (obj) => {
			dispatch(actions.pm.saveComment(obj))
		},
		updateComment: (obj) => {
			dispatch(actions.pm.updateComment(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMPhaseContainer);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMPhaseContainer.js